














































































































































































import { Component, Vue, Provide, Mixins, Watch } from 'vue-property-decorator';
import MixinResults from '../../../plugins/podolib/services/helper/mixins/results';
import { get } from 'lodash';
// Components
import ChartRawFootProgression from '@/components/charts/walking/ChartRawFootProgression.vue';
import ChartRawPronationSupinationAngles from '@/components/charts/walking/ChartRawPronationSupinationAngles.vue';
import ChartsGroupWalkingStepsFeet from '@/components/charts/groups/ChartsGroupWalkingStepsFeet.vue';
import ChartRawClearanceSteppage from '@/components/charts/walking/ChartRawClearanceSteppage.vue';
import ElementBlocInterpretation from '@/components/elements/ElementBlocInterpretation.vue';
import ElementBlocGeneralInterpretation from '@/components/elements/ElementBlocGeneralInterpretation.vue';
import PatientAcquisitionComments from '@/components/patients/PatientAcquisitionComments.vue';
import ElementResultsTooltip from '@/components/elements/ElementResultsTooltip.vue';
import ElementInterpretationManualBanner from '@/components/elements/ElementInterpretationManualBanner.vue';

@Component({
  components: {
    ChartRawFootProgression,
    ChartRawPronationSupinationAngles,
    ChartsGroupWalkingStepsFeet,
    ChartRawClearanceSteppage,
    ElementBlocInterpretation,
    ElementBlocGeneralInterpretation,
    PatientAcquisitionComments,
    ElementResultsTooltip,
    ElementInterpretationManualBanner,
  },
})
export default class PatientResultsWalkingAngular extends Mixins(MixinResults) {
  advancedMode = false;
  relativeMode = false;

  canDisplayProgressionAngle(type: string): boolean {
    return (
      // @ts-ignore
      !!get(this[type].computed_data, 'left.aggregates.foot_progression_angle_FF', null)
    );
  }
  canDisplayClearanceSteppage(type: string): boolean {
    return (
      // @ts-ignore
      !!get(this[type].computed_data, 'left.aggregates.clearance', null)
    );
  }

  getCols(basicValue: number) {
    return this.compareAcquisition ? 12 : basicValue;
  }
}
